import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import isFunction from 'lodash/isFunction';

import AuthManager from "../../services/AuthManager";
import AuthApp from "../AuthApp";
import {sessionCheck} from "../../actions/auth";
import { config } from 'hub-redux-auth';
import { Route } from 'react-router-dom';
import { RedirectionService } from 'hub-redux-auth';
import { setupProductRedirection } from '../../services/utils';
import { merchantActions } from '@store/ducks';


const mapDispatchToProps = (dispatch) => ({
  saveAllowedQueryParams: queryParams => dispatch(merchantActions.saveAllowedQueryParams(queryParams))
});

@connect(state => ({ session: state.session }), mapDispatchToProps)
class SessionCheck extends React.Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    history: PropTypes.shape({
      push: PropTypes.func,
      replace: PropTypes.func,
    }).isRequired,
  };

  componentWillMount() {
    sessionCheck(this.props.dispatch);
    setupProductRedirection(window);
    // this.props.saveAllowedQueryParams(window.location);
  }

  componentWillReceiveProps(nextProps) {
  }

  render() {
    return <AuthApp {...this.props} />;
  }
}

export default connect()(SessionCheck);
